import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BreadcrumbModel } from 'app/shared/breadcrumb/breadcrumb.models';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class BreadcrumbService {

    public data = new ReplaySubject<BreadcrumbModel>(1)
    private apiKey

    constructor(private http: HttpClient) {
    }

    public setApiKey(key) {
        this.apiKey = { 'X-Api-Key': key }
    }

    public loadBreadcrumb(): Observable<BreadcrumbModel> {
        let headers = { 'Accept': 'application/json', ...this.apiKey }
        this.http.get<BreadcrumbModel>('/_mvc/booking/steps/', { headers }).subscribe(x => this.data.next(x))
        return this.data;
    }
}
